/**
 * CARTO raster basemaps (Positron light_all). Requires REACT_APP_CARTO_BASEMAP_API_KEY.
 * @see https://carto.com/basemaps/apikey/
 */
const CARTO_LIGHT_ALL_BASE =
  'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';

export const CARTO_BASEMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';

export function getCartoLightAllTileUrl() {
  const key = process.env.REACT_APP_CARTO_BASEMAP_API_KEY;
  if (key && String(key).trim()) {
    return `${CARTO_LIGHT_ALL_BASE}?key=${encodeURIComponent(String(key).trim())}`;
  }
  return CARTO_LIGHT_ALL_BASE;
}
